import moment from "moment";

module.exports = (config) => {
  const { vendor } = JSON.parse(config.data);

  return {
    client: "dlc",
    ...VENDORS[vendor],
  };
};

const VENDORS = {
  azure: {
    client_key: "dlc",
    expires_in: "3600",
    issued_at: moment().add(1, "hour").toJSON(),
    token:
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjbGllbnRfa2V5IjoiZGxjIiwidXNlciI6eyJpZCI6NiwibmFtZV92Y2giOiJSb3NzIEJveGFsbCIsImVtYWlsX3ZjaCI6InJib3hhbGxAbWVzc2FnZWJyb2FkY2FzdC5jb20iLCJwYXNzd29yZF92Y2giOm51bGwsImFjdGl2ZV90aSI6MSwic291cmNlX3ZjaCI6InNzby5henVyZSIsImNyZWF0ZWRfZHQiOiIyMDIxLTA4LTEwVDIxOjE4OjMzLjAwMFoiLCJ1cGRhdGVkX2R0IjoiMjAyMS0wOC0xMFQyMToxODozMy4wMDBaIiwicGVybWlzc2lvbnMiOnsiaWQiOjYsInVzZXJfaWQiOjYsInBlcm1pc3Npb25zIjpbImFjY291bnQucmVhZFdyaXRlIiwic3dpdGNoYm9hcmQud3JpdGUiXX19LCJjb25maWciOnsiZGJuYW1lIjoiZGxjIn0sImlhdCI6MTYyODYzNzYwMywiZXhwIjoxNjI4NjQxMjAzLCJpc3MiOiJwcmVmZXJlbmNlLXBvcnRhbC1hcGkifQ.bAYgKl4aRUB6lKKU40bQH7iN1eR9uwOpJk-WXog706o",
    user: {
      id: 6,
      name_vch: "Mock User",
      email_vch: "mock@email.com",
      password_vch: null,
      active_ti: 1,
      source_vch: "sso.azure",
      created_dt: "2021-08-10T21:18:33.000Z",
      updated_dt: "2021-08-10T21:18:33.000Z",
      permissions: {
        id: 6,
        user_id: 6,
        permissions: ["account.readWrite", "switchboard.readWrite"],
      },
    },
  },
};
